
    // IMPORTS
    import { computed, defineComponent } from 'vue'
    import { useEquipmentStore } from '@/store/equipment';
    import { useBrowserStateStore } from '@/store/browserState';
    import { buildLocalization } from '@/util'

    import myGrid from '@/components/grid/my-grid.vue'

    import { GridColumnProps } from '@progress/kendo-vue-grid';
    import { IVarConfItemDTO } from '@/types/equipment';

    interface IConfItemRow {
        positionNo: number,
        propertyText: string,
        propertyValues: string[]
    }

    export default defineComponent({
        name: 'equipmentConfiguration',

        components: {
            myGrid,
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const equipmentStore = useEquipmentStore()
            const browserState = useBrowserStateStore()

            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const confItems = computed(() => transform(equipmentStore.varConfItems))
            const columns = computed(() => [
                {
                    field: 'propertyText',
                    title: localize('Property'),
                    width: isNarrowScreen.value ? 170 : 300,
                },
                {
                    field: 'propertyValues',
                    title: localize('Value'),
                    cell: 'custom1'
                }
            ] as GridColumnProps[])

            /** Indicates whether the current browser width is narrow */
            const isNarrowScreen = computed(() => (browserState.resolution?.width ?? 1200) < 600)

            const computedData = { confItems, columns, isNarrowScreen }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization();

            const publicMethods = { localize }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function transform(items: IVarConfItemDTO[] | null): IConfItemRow[] | null {
                if (items == null) return null

                const itemLookup = items.toLookup(item => key(item))
                const result: IConfItemRow[] = []

                for (const key of Array.from(itemLookup.keys())) {
                    const itemGroup = itemLookup.get(key)

                    if (itemGroup?.length) {
                        result.push({
                            positionNo: itemGroup[0].positionNo,
                            propertyText: itemGroup[0].propertyText,
                            propertyValues: itemGroup
                                .map(grp => grp.propertyValue)
                                .sortBy(v => v)
                        })
                    }
                }

                return result.sortBy(i => i.positionNo)
            }

            function key(item: IVarConfItemDTO): string {
                return `${item.positionNo}/${item.propertyText}`
            }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
